export default class IndustryService {
  getAll() {
    return fetch("https://api.tradersr.com/api/industry")
      .then(res => res.json());
  }
}